import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Orbitron', monospace;
    background: linear-gradient(135deg, #0a0a12 0%, #1a1a2e 100%);
    min-height: 100vh;
    color: #ffffff;
    overflow-x: hidden;
  }

  #root {
    min-height: 100vh;
  }

  /* Custom scrollbar */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #0a0a12;
  }

  ::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #00d4ff, #8a2be2);
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, #8a2be2, #00d4ff);
  }

  /* Selection styles */
  ::selection {
    background: #00d4ff;
    color: #0a0a12;
  }

  ::-moz-selection {
    background: #00d4ff;
    color: #0a0a12;
  }

  /* Smooth scrolling */
  html {
    scroll-behavior: smooth;
  }

  /* Link styles */
  a {
    color: inherit;
    text-decoration: none;
    transition: all 0.3s ease;
  }

  a:hover {
    color: #00d4ff;
  }

  /* Button reset */
  button {
    border: none;
    background: none;
    cursor: pointer;
    font-family: inherit;
  }

  /* Responsive text */
  @media (max-width: 768px) {
    body {
      font-size: 14px;
    }
  }
`; 